module.exports = __webpack_public_path__ + "img/call-center-phone.c7cc8f70.png";